import { Config } from "../../../../api/config";
// API keys
export var PurchaseRequisitionKeys = {
    Paging: "purchaseRequisitionPaging",
    Create: "purchaseRequisitionCreate",
    Update: 'PurchaseRequisitionUpdate',
    Get: 'PurchaseRequisitionGet',
    Cancel: "purchaseRequisitionCancel",
    ProductList: "productListGet",
    DepartmentList: "departmentListGet",
    PriorityList: "priorityListGet",
    ProcurementTypeList: "procurmentTypeListGet",
    UOMList: "uomListGet",
    SupplierList: "supplierListGet",
    PartListByName: "partListByNameGet",
    ProxyList: "proxyListGet",
    StatusProgressList: 'getStatusProgressLists',
    PurchaseProcurementPartList: 'getPurchaseProcurementPartList',
    PartDetailsByProductId: 'getPartDetailsByProductId',
    AttachmentList: "getAttachmentList",
    CancellationReasonPR: "getCancellationReasonList",
    Upload: 'purchaseRequisitionUpload',
    AttachmentSystemName: 'PurchaseProcurementAttachment'
};
// API calls
export var purchaseRequisationPagingAPI = "".concat(Config.baseURL, "PurchaseProcurement/Paging");
export var purchaseRequisationCreateAPI = "".concat(Config.baseURL, "PurchaseProcurement/CreatePurchaseProcurement");
export var searchPartByProductCodeAndNameAPI = "".concat(Config.baseURL, "PurchaseProcurement/SearchByProductCodeAndName");
export var procurementTypeListAPI = "".concat(Config.baseURL, "ProcurementType/List");
export var supplierListAPI = "".concat(Config.baseURL, "Supplier/ListOrganization");
export var departmentListAPI = "".concat(Config.baseURL, "Department/List");
export var productListAPI = "".concat(Config.baseURL, "Product/List");
export var priorityListAPI = "".concat(Config.baseURL, "Priority/List");
export var priorityListAPIUrl = "".concat(Config.baseURL, "Priority/PriorityByName");
export var uomListAPI = "".concat(Config.baseURL, "UnitOfMeasurement/List");
export var partDetailsByProductIdAPI = "".concat(Config.baseURL, "PurchaseProcurementDetail/PartDetails");
export var purchaseRequisitionGetAPI = function (id) { return "".concat(Config.baseURL, "PurchaseProcurement/").concat(id, "/Get"); };
export var purchaseRequisitionUpdateAPI = function (id) { return "".concat(Config.baseURL, "PurchaseProcurement/").concat(id, "/UpdatePurchaseProcurement"); };
export var statusProgressListAPI = "".concat(Config.baseURL, "DocumentStatus/DocumentStatusList");
export var purchaseProcurementDetailsByProcurementIdAPI = "".concat(Config.baseURL, "PurchaseProcurementDetail/FindPurchaseProcurementId");
export var attachmentListAPI = "".concat(Config.baseURL, "PurchaseProcurementAttachment/ByPurchaseProcurementId");
export var partDetailsListAPI = "".concat(Config.baseURL, "PurchaseProcurementDetail/PartDetails");
export var cancelationReasonPRListAPI = "".concat(Config.baseURL, "CancellationReason/List");
export var cancelPurchaseRequisitionAPI = function (id) { return "".concat(Config.baseURL, "PurchaseProcurement/").concat(id, "/CancelledPurchaseProcurement"); };
export var purchaseRequisitionAttachmentCreateAPI = "".concat(Config.baseURL, "PurchaseProcurementAttachment/Create");
export var purchaseRequisitionAttachmentDeleteAPI = "".concat(Config.baseURL, "PurchaseProcurementAttachment/Delete");
// constants
export var viewTypeOptions = ["My requisitions", "All requisitions"];
export var PurchaseRequisitionMandatoryFeilds = {
    'ChildId': 'Product',
    'Quantity': 'Quantity'
};
